import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  hourlyRate,
  totalWorkMinutes,
  jobTitle,
  externalId,
`

export const getRhDatasByDayQuery = (brandId, establishmentId, day) => {
    var debug = `
    query {
      getRhDatas(brandId: "${brandId}", establishmentId: "${establishmentId}", day:"${day}") {
        ${common}
      }
    }
  `
    console.log(debug);

    return gql`
    query {
      getRhDatas(brandId: "${brandId}", establishmentId: "${establishmentId}", day:"${day}") {
        ${common}
      }
    }
  `;
}

export const  getRhDatasByRangeQuery = (brandId, establishmentId, startDay, endDay) => {

    var debug = `
    query {
      getRhDatasByRange(brandId: "${brandId}", establishmentId: "${establishmentId}", startDay:"${startDay}", endDay:"${endDay}") {
        ${common}
      }
    }
  `
    console.log(debug);

    return gql`
    query {
      getOrdersByRange(brandId: "${brandId}", establishmentId: "${establishmentId}", startDay:"${startDay}", endDay:"${endDay}") {
        ${common}
      }
    }
  `;
}




